'use client';

import { COLORS } from '@/constants';
import styled from 'styled-components';

export const StyledLink = styled.a`
  font-size: 14px;
  color: ${COLORS['primary/900']};
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  font-family: inherit;

  &:visited {
    color: ${COLORS['primary/900']};
  }

  &:hover {
    color: ${COLORS['secondary/500']};
    text-decoration: underline;
  }
`;
